const numeral = require('numeral')
const NumberSuffix = require('number-suffix')

export const formatValue = (val, precision = 2, format = '$0,0') => {
    if (val === 0) return "-";
    if (val < 1000000) {
        format = '$0,0.00'
    }
    val = NumberSuffix.format(val, { precision: precision, measurement: 'million' }).split('M')[0];
    return numeral(val).format(format) + " M";
}

export const formatValueNumeral = numeral

const suffix = (val, measurement, suffix, precision = 2, format = '$0,0') => {
    if (val === 0) return "-";
    val = NumberSuffix.format(val, { precision: precision, measurement: measurement }).split(suffix)[0];
    return numeral(val).format(format).split(',')[0] + suffix
}

export const formatValueV2 = (val, format = '$0,0') => {
    if (val < 1000) {
        return numeral(val).format(format)
    }
    if (val < 1000000) {
        //console.log(val, val/1000)
        return suffix(val, 'thousand', ' K', 2, format)
    }
    return formatValue(val, 2, format)
}


export const makeCancelable = (promise) => {
    let hasCanceled_ = false;

    const wrappedPromise = new Promise((resolve, reject) => {
        promise.then(
            val => hasCanceled_ ? reject({ isCanceled: true }) : resolve(val),
            error => hasCanceled_ ? reject({ isCanceled: true }) : reject(error)
        );
    });

    return {
        promise: wrappedPromise,
        cancel() {
            hasCanceled_ = true;
        },
    };
};